import styled from 'styled-components';
export const SidebarContainer = styled.div `
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
